import { render, staticRenderFns } from "./finx-layout.vue?vue&type=template&id=264d61da"
import script from "./finx-layout.vue?vue&type=script&lang=ts"
export * from "./finx-layout.vue?vue&type=script&lang=ts"
import style0 from "./finx-layout.vue?vue&type=style&index=0&id=264d61da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports